import { Component, inject, DOCUMENT } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "./services/language.service";
import { ActivatedRoute, RouterOutlet } from "@angular/router";
import { ConfigService } from "./services/config.service";

import { MessageService } from "./services/message.service";
import { LoaderComponent } from "./loader/loader.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  imports: [RouterOutlet, LoaderComponent],
})
export class AppComponent {
  public title = "Order Portal";

  private translate = inject(TranslateService);
  private languageService = inject(LanguageService);
  private route = inject(ActivatedRoute);
  private configService = inject(ConfigService);
  private messageService = inject(MessageService);
  private document = inject(DOCUMENT);

  constructor() {
    this.route.queryParams.subscribe((params) => {
      if (
        params.lang === "nl" ||
        params.lang === "en" ||
        params.lang === "de" ||
        params.lang === "el"
      ) {
        this.chosenLanguage(params.lang);
      }
    });

    let language = "nl";
    try {
      language = localStorage.getItem("language") || "";
      language = language.toLowerCase();
    } catch {
      language = "nl";
    }

    this.chosenLanguage(language);

    this.loadStyle(this.configService.getStyleUrl());

    this.messageService.getMessage().subscribe((response) => {
      this.chosenLanguage(response.text);
    });
  }

  loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName("head")[0];

    const themeLink = this.document.getElementById(
      "client-theme",
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement("link");
      style.id = "client-theme";
      style.rel = "stylesheet";
      style.type = "text/css";
      style.href = `${styleName}`;
      head.appendChild(style);
    }
  }

  chosenLanguage(language) {
    if (language === "") {
      language = "nl";
    }
    LanguageService.setCurrentLanguage(language);
    this.translate.setDefaultLang(language);
  }
}
